import { render, staticRenderFns } from "./AddBaseMaterials.vue?vue&type=template&id=23580eca&scoped=true&"
import script from "./AddBaseMaterials.vue?vue&type=script&lang=js&"
export * from "./AddBaseMaterials.vue?vue&type=script&lang=js&"
import style0 from "./AddBaseMaterials.vue?vue&type=style&index=0&id=23580eca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23580eca",
  null
  
)

export default component.exports